import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstLetters',
})
export class FirstLettersPipe implements PipeTransform {
  public transform(value: string): string {
    if (!value) return '';

    const words = value.split(' ');

    const firstTwoWords = words.slice(0, 2);

    if (firstTwoWords.length === 1) {
      return firstTwoWords[0].charAt(0).toUpperCase() + firstTwoWords[0].charAt(1);
    }

    return firstTwoWords.map((word) => word.charAt(0).toUpperCase()).join('');
  }
}
